import { render, staticRenderFns } from "./LessonChat.vue?vue&type=template&id=42fe96de&scoped=true&"
import script from "./LessonChat.vue?vue&type=script&lang=js&"
export * from "./LessonChat.vue?vue&type=script&lang=js&"
import style0 from "./LessonChat.vue?vue&type=style&index=0&id=42fe96de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fe96de",
  null
  
)

export default component.exports